// extracted by mini-css-extract-plugin
export default {"item":"SignQrCode_item__tuFsx","icon":"SignQrCode_icon__eRhYf","content":"SignQrCode_content__Y2vHn","button":"SignQrCode_button__ITFY9"};